import { useMemo, useEffect, memo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';
import { useRelevancyFeed } from '../model';

import SandEComponent from './SandEComponent';

import type { EditorialContent } from '@cobalt/utilities';
import { mapEditorialContent } from '@cobalt/utilities';
import { useVideoLinkRule } from '@hooks/useLinkRule';
import { useVideoFromMas } from '@shared/VideoPlayer/hooks/useMediaAssetService';

const SkillsComponent = (props: RelevancyCardProps) => {
  const { item } = props;
  const { toggleCardHidden } = useRelevancyFeed();

  const teaser: EditorialContent = useMemo(() => {
    const firstItem = Array.isArray(item?.teaser) ? item.teaser[0] : (item?.teaser ?? {});
    return firstItem.sys ? mapEditorialContent(firstItem, null, true) : firstItem;
  }, [item.teaser]);

  const availableVideo = useVideoFromMas(teaser);
  useEffect(() => {
    toggleCardHidden(item, !availableVideo);
  }, [availableVideo, item, toggleCardHidden]);

  const cardType = useMemo(() => item.subType?.replaceAll(' ', '-').toLowerCase(), [item.subType]);
  const trackName = useMemo(() => item?.subType?.replace('Moments', 'Skills').replaceAll('-', ' '), [item.subType]);

  const trackingData = useMemo(() => {
    return { name: trackName, id: teaser.id, category: 'sponsored card' };
  }, [teaser?.id, trackName]);

  const href = useVideoLinkRule(teaser.id);

  return (
    <SandEComponent
      {...props}
      cardType={cardType}
      fetchArticle={!teaser.id}
      logoByLanguage
      url={href}
      buttonTag='watch-all-skills'
      video={teaser.id ? teaser : undefined}
      isVideoPlayer
      trackingData={trackingData}
    />
  );
};

export default memo(SkillsComponent);
